var App = App || {};

App.Header = (function ($) {
    'use strict';

    function MegaMenu() {

        let mmActive = false;
        const mmSpeed = 200;
        const mmTimer = 300;

        let mmOpenTimer;
        let mmCloseTimer;

        const mmContainer = $("header .header-primary > nav > ul");
        const mmTrigger = mmContainer.children("li").children("a, button");
        const mmItems = mmContainer.find(".mega-menu").find("a");

        let mmActiveItems = [];
        let mmActiveItem = 0;

        mmItems.attr("tabindex", -1);

        mmContainer.on("mouseleave", function () {
            mmActive = false;
            mmTrigger.trigger("blur");

            mmCloseTimer = window.setTimeout(function () {
                MegaMenuClose(mmTrigger, mmSpeed);
            }, mmTimer);
        }).on("keydown", function (e) {
            if (e.key === "Tab") {
                mmActive = false;
                MegaMenuClose($(this).children("li").children("a, button"), 1);
            }
        });

        mmTrigger.on("mouseenter", function () {
            var $this = $(this);

            window.clearTimeout(mmOpenTimer);

            mmOpenTimer = window.setTimeout(function () {
                MegaMenuOpen($this, mmSpeed);
            }, mmTimer);

            mmActive = true;
        }).on("focus", function () {
            window.clearTimeout(mmOpenTimer);

            MegaMenuOpen($(this), 1);
            mmActive = true;

            window.clearTimeout(mmCloseTimer);
        }).on("blur mouseleave", function () {
            window.clearTimeout(mmOpenTimer);

            if (mmActive === false) {
                mmCloseTimer = window.setTimeout(function () {
                    MegaMenuClose($(this), 1);
                }, mmTimer);
            }
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItems = [];
                    mmActiveItem = 0;
                    $(this).siblings(".mega-menu").find("a:visible").each(function () { mmActiveItems.push(this); });
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    MegaMenuClose($(this), mmSpeed);
                    break;
            }
        });

        mmItems.on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".mega-menu").parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".mega-menu").parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem < mmActiveItems.length - 1 ? mmActiveItem + 1 : 0;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem > 0 ? mmActiveItem - 1 : mmActiveItems.length - 1;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, megaMenuSpeed);
                    break;
            }
        });

    }

    function MegaMenuOpen(trigger, speed) {
        trigger.attr("aria-expanded", "true").siblings(".mega-menu").stop().slideDown(speed);
        MegaMenuClose(trigger.parents("li").siblings("li").children("a, button"), speed);
    }

    function MegaMenuClose(trigger, speed) {
        trigger.attr("aria-expanded", "false").siblings(".mega-menu").stop().slideUp(speed);
    }

    return {
        MegaMenu: MegaMenu
    };

})(jQuery);